import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CryptoService } from '@core/crypto-module/crypto.service';
import { LocationService } from '@core/location-required/location-required.service';
import { environment } from 'src/environments/environment';
import packageJson from 'package.json';
import { ENC_DOMAIN_NAME } from '@core/services/domain-name.token';

export const everyRequiestTokenInterceptor: HttpInterceptorFn = (req, next) => {

  const headers: Record<string, string> = {
    'Noisrev': btoa(packageJson.version),
    'Emanetis': btoa(packageJson.name),
    'Niamod': inject(ENC_DOMAIN_NAME)
  };

  if (environment.environmentName !== 'uat') {
    let locationData: GeolocationCoordinates = inject(LocationService).coords() as GeolocationCoordinates;

    let lati_long = btoa(locationData.latitude + '-' + locationData.longitude);
    headers['X-Frontend-Token'] = inject(CryptoService).generateFrontendToken();
    headers['lat_long'] = lati_long;
  }

  let newReq = req.clone({
    setHeaders: headers
  });

  return next(newReq);
};

